import React, {useEffect} from 'react';
import MortgageForm from "../../../../../components/data-capture/MortgageForm";
import {Alert, Checkbox, Col, Form, Input, InputNumber, Row} from "antd";
import {currencyFormatter, currencyParser} from "../../../../../../assets/scripts/parser-functions";
import ButtonAsync from "../../../../../components/elements/ButtonAsync";
import {getItemFromPath} from "../../../MortgageProvider";
import {
    CustomVariableFrom
} from "../../../../../components/client/application/forms/sections/ApplicantEmploymentIncome";

function ApplicationForm({section, inExtWindow = true}) {
    let target = section.applicant === 1 ? `applicant1` : `applicant2`
    console.log({section})
    let questions = [
        {
            name: 'positionHeld',
            label: 'Position Held',
            answer: {
                type: 'text',
            },
            target: !section.index ? `${target}.employment.positionHeld` : `${target}.employmentIncome[${section.index}].positionHeld`
        }, {
            name: 'publicSector',
            label: 'Sector',
            answer: {
                type: 'select',
                choices: [
                    {
                        value: true,
                        text: 'Public'
                    }, {
                        value: false,
                        text: 'Private'
                    }
                ]
            },
            target: !section.index ? `${target}.employment.publicSector` : `${target}.employmentIncome[${section.index}].publicSector`
        },
        {
            name: 'grossBasic',
            label: 'Gross Basic Salary',
            answer: {
                type: 'euro',
            },
            target: !section.index ? `${target}.employment.grossBasic` : `${target}.employmentIncome[${section.index}].grossBasic`
        },
        {
            name: 'contractRequired',
            label: 'Contract Required',
            answer: {
                type: 'select',
                choices:[
                    {text:'Yes', value:true},
                    {text:'No', value:false},
                ]
            },
            target: !section.index ? `${target}.employment.contractRequired` : `${target}.employmentIncome[${section.index}].contractRequired`
        }
    ]

    if (section?.data?.publicSector) {
        questions.push(
            {
                name: 'nextPayScale1',
                label: 'Payscale + 1',
                answer: {
                    type: 'euro',
                },
                target: `${target}.employmentIncome[${section.index}].nextPayScale1`
            },
            {
                name: 'nextPayScale2',
                label: 'Payscale + 2',
                answer: {
                    type: 'euro',
                },
                target: `${target}.employmentIncome[${section.index}].nextPayScale2`
            },
            {
                name: 'nextPayScale3',
                label: 'Payscale + 3',
                answer: {
                    type: 'euro',
                },
                target: `${target}.employmentIncome[${section.index}].nextPayScale3`
            }
        )
    }
    const existingDocContent1 = section.mortgage.docContents.find(parg => {
        return parg.document === 'coverLetter' && parg.paragraph === `app${section.applicant}SalaryCertEmploymentStartDateMismatch`
    })
    const existingDocContent2 = section.mortgage.docContents.find(parg => {
        return parg.document === 'coverLetter' && parg.paragraph === `app${section.applicant}SalaryCertGrossBasicMismatch`
    })
    useEffect(() => {
        const timer = setTimeout(() => {
            const mismatchProblem1 = section.problems.find(p => p.name === 'EMPLOYMENT_START_DATE_MISMATCH')
            const mismatchProblem2 = section.problems.find(p => p.name === 'GROSS_BASIC_MISMATCH')
            const creations = []
            const deletions = []
            if (mismatchProblem1 && !existingDocContent1) {
                // add doc content to explain the mismatch problem
                creations.push({
                    target: 'docContents',
                    pairs: {
                        document: 'coverLetter',
                        paragraph: `app${section.applicant}SalaryCertEmploymentStartDateMismatch`,
                        mortgageID: section.mortgage.id,
                    }
                })
            } else if (!mismatchProblem1 && existingDocContent1) {
                deletions.push({
                    target: 'docContents',
                    id: existingDocContent1.id
                })
            }
            if (mismatchProblem2 && !existingDocContent2) {
                // add doc content to explain the mismatch problem
                creations.push({
                    target: 'docContents',
                    pairs: {
                        document: 'coverLetter',
                        paragraph: `app${section.applicant}SalaryCertGrossBasicMismatch`,
                        mortgageID: section.mortgage.id,
                    }
                })
            } else if (!mismatchProblem2 && existingDocContent2) {
                deletions.push({
                    target: 'docContents',
                    id: existingDocContent2.id
                })
            }
            if (creations.length || deletions.length) {
                const mutation = {}
                if (creations.length) {
                    mutation.create = creations
                }
                if (deletions.length) {
                    mutation.delete = deletions
                }
                section.mortgage.mutate(mutation)
            }
        }, 500)
        return () => clearTimeout(timer)
    }, []);


    if (existingDocContent1 && section.problems.find(p => p.name === 'EMPLOYMENT_START_DATE_MISMATCH')) {
        const question = {
            name: `app${section.applicant}SalaryCertEmploymentStartDateMismatch`,
            label: 'Start Date Mismatch Explanation',
            answer: {
                type: 'paragraphs',
            },
            target: `docContents[${existingDocContent1.id}].html`
        }
        questions.push(question)
    }
    if (existingDocContent2 && section.problems.find(p => p.name === 'GROSS_BASIC_MISMATCH')) {
        const question = {
            name: `app${section.applicant}SalaryCertGrossBasicMismatch`,
            label: 'Gross Basic Mismatch Explanation',
            answer: {
                type: 'paragraphs',
            },
            target: `docContents[${existingDocContent2.id}].html`
        }
        questions.push(question)
    }
    return <>
        <MortgageForm questions={questions} inExtWindow={inExtWindow}/>
        <Alert message="Variable Income needs to be saved separately"/>
        <CustomVariableFrom applicant={section.applicant} mortgage={section.mortgage} job={section.data}/>
    </>
}

export default ApplicationForm;